export const WHATSAPP_LINK: string = "https://chat.whatsapp.com/KrAVCVZxg4tCxyELHZ20RH?mode=ac_c";
